module.exports = __webpack_public_path__ + "static/media/29BDOS20.ebf36560.jpg";